import { getThemeData } from './theme-data';

export const getReCAPTCHAResponse = async (action) => {
	try {
		const themeData = await getThemeData();
		if (!themeData.recaptcha_site_key) {
			throw new Error('Missing Google reCAPTCHA Site Key in theme configuration');
		}
		if (!themeData.ajax_actions?.recaptcha_verify) {
			throw new Error('Missing AJAX route to verify reCAPTCHA token');
		}
		if (!themeData.ajax_route) {
			throw new Error('Missing global AJAX route');
		}

		return new Promise((resolve, reject) => {
			if (window.grecaptcha === undefined) {
				console.warn('Google reCAPTCHA is not loaded');
				resolve({ success: true, score: 1 });
			} else {
				window.grecaptcha.ready(function () {
					window.grecaptcha.execute(themeData.recaptcha_site_key, { action }).then(async function (token) {
						const formData = new FormData();
						formData.append('action', themeData.ajax_actions.recaptcha_verify);

						// Determine if request is just a test
						const testParam = 'e2e-test';
						const url = new URL(window.location);
						if (url.searchParams.has(testParam)) {
							token = 'e2e-test-valid-user';
						}

						// Set reCAPTCHA token
						formData.append('recaptcha_token', token);

						try {
							const response = await fetch(themeData.ajax_route, {
								method: 'POST',
								body: formData,
							});
							const json = await response.json();
							if (json.success) {
								resolve(json);
							} else if (json['error-codes']) {
								/**
								 * reCAPTCHA verification error codes
								 * @link https://developers.google.com/recaptcha/docs/verify#error_code_reference
								 *
								 * missing-input-secret	  The secret parameter is missing.
								 * invalid-input-secret	  The secret parameter is invalid or malformed.
								 * missing-input-response	The response parameter is missing.
								 * invalid-input-response	The response parameter is invalid or malformed.
								 * bad-request	          The request is invalid or malformed.
								 * timeout-or-duplicate	  The response is no longer valid: either is too old or has been used previously.
								 */
								let errorMessages = [];
								json['error-codes'].forEach((errorCode) => {
									switch (errorCode) {
										case 'missing-input-secret':
											errorMessages.push('The secret parameter is missing.');
											break;
										case 'invalid-input-secret':
											errorMessages.push('The secret parameter is invalid or malformed.');
											break;
										case 'missing-input-response':
											errorMessages.push('The response parameter is missing.');
											break;
										case 'invalid-input-response':
											errorMessages.push('The response parameter is invalid or malformed.');
											break;
										case 'bad-request':
											errorMessages.push('The request is invalid or malformed.');
											break;
										case 'timeout-or-duplicate':
											errorMessages.push('The response is no longer valid: either is too old or has been used previously.');
											break;
										default:
											errorMessages.push('Unknown reCAPTCHA error code');
									}
								});
								throw new Error(`There was an error when trying to verify the user's response by reCAPTCHA:\n${errorMessages.join('\n')}`);
							} else if (json.data) {
								throw new Error(`The request to verify the reCAPTCHA user token failed: ${response.data}`);
							} else {
								throw new Error('Unknown error occurred when trying to verify the reCAPTCHA user token');
							}
						} catch (e) {
							reject(e);
						}
					});
				});
			}
		});
	} catch (e) {
		console.error(e);
	}
};
